import { render, staticRenderFns } from "./RelatorioMeioComunicacao.vue?vue&type=template&id=2f2a1188&scoped=true&"
import script from "./RelatorioMeioComunicacao.vue?vue&type=script&lang=js&"
export * from "./RelatorioMeioComunicacao.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioMeioComunicacao.vue?vue&type=style&index=0&id=2f2a1188&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2a1188",
  null
  
)

export default component.exports